import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

/* ====== IMPRESSÃO: Espelho de Recebimento (?tipo=espelho) | Ticket de Pesagem (?tipo=ticket) ====== */

const fmtDT = (s) => (s ? new Date(s).toLocaleString("pt-BR") : "—");
const kg = (v) => (v != null ? `${Number(v).toLocaleString("pt-BR")} kg` : "—");

export default function PrintAgendamento() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const tipo = params.get("tipo") || "espelho";
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/logistica/agendamentos/${id}`).then(({ data }) => {
      setData(data);
      setTimeout(() => window.print(), 600);
    }).catch(() => {});
  }, [id]);

  if (!data) return <div className="p-10 font-mono text-sm">Carregando documento...</div>;
  const { agendamento: ag, itens } = data;

  return (
    <div className="bg-white text-black min-h-screen p-8 font-sans text-[12px]" data-testid="print-page">
      <style>{`@media print { .no-print { display: none } } body { background: #fff }`}</style>
      <button onClick={() => window.print()} className="no-print mb-4 border border-black px-4 py-2 text-xs font-bold uppercase">Imprimir</button>

      {/* Cabeçalho */}
      <div className="flex justify-between items-start border-b-2 border-black pb-3">
        <div>
          <div className="text-xl font-black">CHEM·WMS — {tipo === "espelho" ? "ESPELHO DE RECEBIMENTO" : "TICKET DE PESAGEM"}</div>
          <div className="text-[11px]">Base {ag.base} · Documento gerado em {new Date().toLocaleString("pt-BR")}</div>
        </div>
        <div className="text-right">
          <div className="font-mono text-lg font-black">{ag.numero}</div>
          <div className="text-[11px]">Doca {ag.doca_codigo}</div>
        </div>
      </div>

      {/* Dados do transporte */}
      <table className="w-full mt-3 text-[11px]">
        <tbody>
          <tr>
            <td className="py-1"><b>Fornecedor:</b> {ag.fornecedor_nome}</td>
            <td><b>Motorista:</b> {ag.motorista}</td>
            <td><b>CPF:</b> {ag.cpf}</td>
            <td><b>Placa:</b> <span className="font-mono">{ag.placa}</span></td>
          </tr>
          <tr>
            <td className="py-1"><b>Planejado:</b> {ag.data_planejada?.split("-").reverse().join("/")} {ag.hora_planejada}</td>
            <td><b>Chegada:</b> {fmtDT(ag.hora_chegada)}</td>
            <td><b>Check-In:</b> {fmtDT(ag.hora_checkin)}</td>
            <td><b>Check-Out:</b> {fmtDT(ag.hora_checkout)}</td>
          </tr>
        </tbody>
      </table>

      {tipo === "ticket" && (
        <div className="mt-4 border-2 border-black">
          <div className="bg-black text-white px-3 py-1 font-bold uppercase text-[11px]">Pesagem Oficial</div>
          <table className="w-full text-center">
            <thead>
              <tr className="border-b border-black text-[10px] uppercase">
                <th className="py-2">Peso Inicial (Cheio)</th>
                <th>Peso Final (Vazio)</th>
                <th>Peso Líquido Recebido</th>
              </tr>
            </thead>
            <tbody>
              <tr className="font-mono text-xl font-black">
                <td className="py-3">{kg(ag.peso_inicial)}</td>
                <td>{kg(ag.peso_final)}</td>
                <td className="bg-gray-100">{kg(ag.peso_liquido)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Itens */}
      <div className="mt-4 font-bold uppercase text-[11px]">{tipo === "espelho" ? "Contentores agendados — conferir físico contra este espelho" : "Resumo da conferência"}</div>
      <table className="w-full mt-1 border-collapse text-[10px]">
        <thead>
          <tr className="border-y-2 border-black text-left uppercase">
            <th className="py-1 pr-2">#</th>
            <th className="pr-2">Pedido</th>
            <th className="pr-2">Item</th>
            <th className="pr-2">Contentor</th>
            <th className="pr-2">Produto</th>
            <th className="pr-2">Qtd</th>
            <th className="pr-2">Lacres</th>
            <th className="pr-2">Tara</th>
            <th className="pr-2">Lote</th>
            <th className="pr-2">Validade</th>
            <th className="pr-2">NF Prod.</th>
            <th className="pr-2">NF Cont.</th>
            {tipo === "espelho" ? (
              <th className="pr-2">Conferido ✔</th>
            ) : (
              <><th className="pr-2">Status</th><th className="pr-2">Qtd Receb.</th><th>Divergência</th></>
            )}
          </tr>
        </thead>
        <tbody>
          {itens.map((it, i) => (
            <tr key={it.id} className="border-b border-gray-400">
              <td className="py-1 pr-2">{i + 1}</td>
              <td className="pr-2">{it.pedido || "—"}</td>
              <td className="pr-2">{it.item || "—"}</td>
              <td className="pr-2 font-mono font-bold">{it.contentor}</td>
              <td className="pr-2">{it.produto || "—"}</td>
              <td className="pr-2 font-mono">{it.qtd || "—"}</td>
              <td className="pr-2 font-mono">{it.lacres || "—"}</td>
              <td className="pr-2 font-mono">{it.tara || "—"}</td>
              <td className="pr-2 font-mono">{it.lote || "—"}</td>
              <td className="pr-2 font-mono">{it.validade_lote || "—"}</td>
              <td className="pr-2 font-mono">{it.nf_produto || "—"}</td>
              <td className="pr-2 font-mono">{it.nf_contentor || "—"}</td>
              {tipo === "espelho" ? (
                <td className="pr-2 text-center">[&nbsp;&nbsp;&nbsp;]</td>
              ) : (
                <>
                  <td className="pr-2 font-bold">{(it.status_conferencia || "").replace("_", " ")}</td>
                  <td className="pr-2 font-mono">{it.qtd_recebida ?? "—"}</td>
                  <td>{it.divergencia_obs || "—"}</td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Assinaturas */}
      <div className="mt-12 grid grid-cols-2 gap-16">
        <div className="border-t border-black pt-1 text-center text-[10px] uppercase">
          {tipo === "espelho" ? "Conferente da Doca" : "Operador da Balança"}
        </div>
        <div className="border-t border-black pt-1 text-center text-[10px] uppercase">
          Motorista — {ag.motorista}
        </div>
      </div>
    </div>
  );
}
